<div class="planned-at-loading-dialog">
  <div class="summary-row">
    <div class="route-summary">
      <div class="summary-item"><span>Route Name -<b> {{ routeDetails?.route_label }}</b></span></div>
      <div class="summary-item"><span>Route State -<b> {{ routeDetails?.route_state }}</b></span></div>
      <div class="summary-item"><span>Route Begin -<b> {{ routeDetails?.route_time_window?.begin | dateFormat : 'datetime'}}</b></span></div>
      <div class="summary-item"><span>Route End -<b> {{ routeDetails?.route_time_window?.end | dateFormat : 'datetime'}}</b></span></div>
    </div>
    <div class="pointer-cursor wrap-btn">
      <button type="button" (click)="wrapUnwrap = !wrapUnwrap" pTooltip="Wrap/Unwrap" tooltipPosition="left"
        positionStyle="fixed" class="bg-transparent border-0 p-0">
        <img width="20" height="20" src="./assets/image/wrap.svg" alt="wrap/unwrap" />
      </button>
    </div>
  </div>
  
  <div *ngIf="isLoading" class="loading-container">
    <div class="text-center no-record-label">Loading...</div>
  </div>

  <p-table
    *ngIf="!isLoading"
    [value]="items"
    [scrollable]="true"
    scrollHeight="calc(67vh - 120px)"
    sortField="task_sequence"
    [sortOrder]="1">
    <ng-template pTemplate="header">
      <tr>
        <ng-container *ngFor="let col of columns">
          <th *ngIf="col.id !== 'asc' && col.id !== 'time_window'" [scope]="col.id"
            [ngClass]="wrapUnwrap ? 'breakWrapData' : 'wrapData'" style="text-align: left;min-width:80px !important;"
            pResizableColumn [pSortableColumn]="col.id" [id]="col">
            {{ col.label }} <p-sortIcon [field]="col.id" /></th>
          <th *ngIf="col.id === 'asc' || col.id === 'time_window'" [ngClass]="wrapUnwrap ? 'breakWrapData' : 'wrapData'"
            pResizableColumn style="text-align: left;min-width:80px !important;" [id]="col">
            {{ col.label }}</th>
        </ng-container>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row>
      <tr>
        <td *ngFor="let col of columns" [ngClass]="wrapUnwrap ? 'breakWrapData' : 'wrapData'">
          <ng-container *ngIf="col.id === 'asc'">
            {{ row[col.id] || '' }}
          </ng-container>
          <ng-container *ngIf="col.id === 'route_name'">
            <a href="javascript:void(0)" (click)="openRouteInfo(row)">{{ row[col.id] }}</a>
          </ng-container>
          <ng-container *ngIf="col.id === 'barcode'">
            <a href="javascript:void(0)" (click)="barcodeClicked(row)">{{ row[col.id] }}</a>
          </ng-container>
          <ng-container *ngIf="col.id !== 'asc' && col.id !== 'route_name' && col.id !== 'barcode'">
            {{ row[col.id] }}
          </ng-container>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="columns.length">
          <div class="text-center no-record-label">No records found.</div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
